module.exports = __webpack_public_path__ + "img/order_material_to_excel_style5.f32cf852.png";